import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import {
  Box,
  Typography,
  TextField,
  Avatar,
  IconButton,
  Tooltip,
  CircularProgress
} from "@material-ui/core/"
import styles from "./styles"
import SideBox from "../../../SideBox"
import SendIcon from "@material-ui/icons/Send"
import API from "store/api"
import cloudinary from "cloudinary-core"
import { connectPartner } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
import { useDebounce } from "use-lodash-debounce"

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const GetConnected = ({ classes }) => {
  const dispatch = useDispatch()
  const [searchResults, setSearchResults] = useState([])
  const [isDisconnecting, setIsDisconnecting] = useState({
    id: "",
    loading: false
  })
  const [value, setValue] = useState("")
  const debouncedValue = useDebounce(value, 400)

  useEffect(() => {
    // API.get("/orgs/").then(res => setOrgList(res.body.data))
  }, [])

  const handleConnect = id => {
    setIsDisconnecting({ id, loading: true })
    dispatch(connectPartner([id]))
      .then(res => {
        setIsDisconnecting({ id: "", loading: false })
        dispatch(openSnackBar({ message: "Request sent." }))
      })
      .catch(error => {
        setIsDisconnecting({ id: "", loading: false })
        dispatch(openSnackBar({ message: "Request failed." }))
      })
  }

  const handleSearch = value => {
    if (value.length > 0 && value.match(/\w|[-]/gi)) {
      API.get(`/orgs/${value}`)
        .then(res => {
          setSearchResults([...res.body.data])
        })
        .catch(error => {
          dispatch(
            openSnackBar({
              message: "Error while searching for organizations."
            })
          )
        })
    } else if (value.length > 0) {
      dispatch(
        openSnackBar({
          message: "Invalid character. Allowed characters A-Z, 1-9, or dash (-)"
        })
      )
    }

    if (value.length === 0) {
      setSearchResults([])
    }
  }
  useEffect(() => {
    handleSearch(value)
  }, [debouncedValue])

  const orgAddress = address => {
    let initialOrgAddress = ""
    if (address) {
      try {
        initialOrgAddress =
          JSON.parse(address).city + ", " + JSON.parse(address).state
      } catch (err) {
        console.log(err)
      }
    }
    return initialOrgAddress
  }
  return (
    <Box className={classes.getConnectedContainer}>
      <SideBox
        title={"GET CONNECTED"}
        subtitle={"Connect with other organizations to share content"}
        content={
          <Box className={classes.getConnectedBoxContainer}>
            <Typography className={classes.searchTitle} variant="h6">
              Search
            </Typography>
            <TextField
              className={classes.search}
              onChange={e => setValue(e.target.value)}
            />
            {/* <pre style={{ whiteSpace: "pre-wrap" }}>
              <code>{JSON.stringify(searchResults)}</code>
            </pre> */}
            <Box className={classes.searchContainer}>
              {searchResults &&
                searchResults.map((org, i) => {
                  return (
                    <Box
                      key={i}
                      display="flex"
                      flexWrap="wrap"
                      justifyContent="space-between"
                      className={classes.organizationContainer}
                    >
                      <Box flexGrow={1} display="flex" alignItems="center">
                        <Avatar
                          className={classes.avatarContainer}
                          varient="rounded"
                          src={
                            org.logo &&
                            cl.url(JSON.parse(org.logo).public_id, {
                              width: 150,
                              crop: "scale"
                            })
                          }
                        />
                        <Box flexGrow={1}>
                          <Typography variant="h6" className={classes.name}>
                            {org.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            className={classes.location}
                          >
                            {orgAddress(org.address)}
                          </Typography>
                        </Box>
                        {/* eslint-disable */
                        isDisconnecting.loading &&
                        isDisconnecting.id === org.id ? (
                          <Box className={classes.updateButton}>
                            <CircularProgress color="primary" />
                          </Box>
                        ) : (
                          <Tooltip
                            title="Connect to this organization"
                            placement="top"
                          >
                            <IconButton
                              color="primary"
                              onClick={() => {
                                handleConnect(org.id)
                              }}
                            >
                              <SendIcon />
                            </IconButton>
                          </Tooltip>
                        )
                        /* eslint-disable */
                        }
                      </Box>
                    </Box>
                  )
                })}
            </Box>
          </Box>
        }
      />
    </Box>
  )
}

export default withStyles(styles)(GetConnected)



// WEBPACK FOOTER //
// ./src/components/SideBox/components/GetConnected/index.jsx